import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useLessonFeedbackStatus() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  const markReviewed = ({ feedbackId, status }) =>
    privateFetch.patch(`/v1/admin/lesson-feedback/${feedbackId}/status`, { status });

  return useMutation(markReviewed, {
    onSettled() {
      queryClient.invalidateQueries('lesson-feedback');
    },
  });
}

export default useLessonFeedbackStatus;
